query SupportRequestShow($id: ID!) {
  supportRequest(id: $id) {
    id
    number
    subject
    type
    status
    message
    details
    closedAt
    createdAt
    lastMessageAt
    waitingSince
    utm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
    conversationId
    user {
      id
      email
      displayName
    }
    platform {
      id
      title
    }
    organization {
      id
      title
    }
    assignee {
      id
      displayName
      email
    }
    payment {
      id
      status
      amount {
        value
        currency
      }
    }
    assistantMessages {
      id
      role
      kind
      text
      createdAt
    }
    messages {
      id
      author
      channel
      body
      internal
      viaAssistant
      event
      fromEmail
      skippedAttachments
      hasOriginal
      createdAt
      staff {
        id
        displayName
        email
      }
      eventUser {
        id
        displayName
        email
      }
      attachments {
        name
        mimeType
        size
        url
      }
    }
  }
}
